import { defineStore } from 'pinia';

export default defineStore('locale', {
  state: () => ({
    locale: '',
  }),
  getters: {
    getLocale: (state) => state.locale,
  },
  actions: {
    loadLocale(value) {
      if (!value) {
        this.locale = 'en-US';
      } else {
        this.locale = value;
      }
    },
  },
});
